export enum UserLocaleId {
  default,
  US = 1,
  ChinaChinese = 3,
  ChinaEnglish = 4,
  IndiaEnglish = 5,
  UkEnglish = 7,
  NlEnglish = 8,
  ItalyEnglish = 10,
  FinlandEnglish = 11,
  SwedenEnglish = 12,
  DenmarkEnglish = 13,
  NorwayEnglish = 14,
  PolandEnglish = 15,
  AustraliaEnglish = 28,
  NewZealandEnglish = 29,
  PolandPolish = 31,
  ItalyItalian = 32,
  SwedenSwedish = 33,
  FinlandFinnish = 34,
  NorwayNorwegian = 35,
  NlDutch = 37,
}

export interface User {
  id?: number;
  username?: string;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  statusId?: number;
  statusVal?: string;
  userTypeId?: number;
  userTypeVal?: string;
  roleId?: number;
  roleVal?: string;
  managingOfficeName?: string;
  managingOfficeAddress?: string;
  expiryDate?: string;
  createBy?: string;
  updateBy?: string;
  createTs?: string;
  updateTs?: string;
  selected?: boolean;
  locationReqPending?: string;
  recordReqPending?: string;
  exists?: boolean;
  groups?: [{ [key: string]: string }];
  userCountry?: string;
  userCountrySkey?: number;
  userLob?: string;
  userLobSkey?: number;
  userLocaleId?: UserLocaleId;
}

export enum UserType {
  USER = 1,
  ADMIN = 2,
  SUPER_USER = 3,
}

export enum UserRole {
  USResearcher = 1,
  USBroker,
  DIGUser,
  APACUser,
  EMEAUser,
  InvestorBroker,
  OccupierBroker,
  DandT,
}

export enum userGroupEnum {
  EDP_WRITE_ACCESS_GROUP_NAME = 'EDP Write Access',
  TRUSTED_USER_GROUP_NAME = 'Trusted User',
  PUBLISH_LISTINGS_GROUP_NAME = 'Publish Listings',
  WINDWARD_REPORTS_GROUP_NAME = 'Windward Reports',
  BULK_EDIT = 'Bulk Edit',
  LEASE_AGREEMENT_REVIEWER = 'Lease Agreement Reviewer',
  QC_TEAM = 'QC Team',
}

export enum UserInfoKey {
  USERID_INFO = 'userInfo',
}
